(() => {
  const root = document.querySelector('[data-au-reviews]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const section = root.closest('section');
  const error = section.querySelector('[data-review-error]');
  const retry = section.querySelector('[data-review-retry]');
  let loading = false;
  function mount() {
    root.querySelector('[data-review-status]')?.remove();
    new window.ReviewsWidget('#hadrill-reviews-widget', {
      store: 'hadrillhair.com.au', widget: 'polaris',
      options: {
        types: 'product_review', lang: 'en', per_page: 5,
        enable_sentiment_analysis: false,
        product_review: {sku: root.dataset.reviewSkus, enable_rich_snippets: false},
        header: {enable_summary:true, enable_ratings:true, enable_attributes:false,
          enable_image_gallery:false, enable_percent_recommended:false,
          enable_write_review:true, enable_ask_question:false, enable_sub_header:true,
          rating_decimal_places:1, use_write_review_button:true, enable_if_no_results:false},
        filtering: {enable:true,enable_text_search:false,enable_sorting:true,
          enable_product_filter:false,enable_media_filter:true,enable_overall_rating_filter:true,
          enable_ratings_filters:false,enable_attributes_filters:false},
        reviews: {enable_avatar:false,enable_reviewer_name:true,enable_reviewer_address:false,
          enable_verified_badge:true,enable_subscriber_badge:false,enable_reviewer_recommends:false,
          enable_attributes:false,enable_product_name:true,enable_link_product:false,
          enable_review_title:false,enable_replies:true,enable_images:true,enable_ratings:false,
          enable_share:false,enable_helpful_vote:true,enable_helpful_display:true,
          enable_report:true,enable_date:true,enable_duplicate_reviews:false}
      },
      styles:{
        '--base-font-size':'16px','--common-button-font-family':'DM Sans',
        '--common-button-font-size':'15px','--common-button-font-weight':'400',
        '--common-button-text-transform':'none','--common-button-vertical-padding':'12px',
        '--common-button-horizontal-padding':'24px','--common-button-border-width':'1px',
        '--common-button-border-radius':'4px','--primary-button-bg-color':'#292E43',
        '--primary-button-border-color':'#292E43','--primary-button-text-color':'#FFFFFF',
        '--secondary-button-border-color':'#292E43','--secondary-button-text-color':'#292E43',
        '--common-star-color':'#292E43','--heading-text-color':'#292E43',
        '--heading-text-font-family':'DM Sans','--heading-text-font-weight':'400',
        '--body-text-font-family':'DM Sans','--body-text-color':'#6B6B6B',
        '--body-text-line-height':'1.6','--inputfield-text-font-family':'DM Sans',
        '--input-text-font-size':'16px','--common-border-color':'#E2DCD5',
        '--common-border-width':'1px','--pagination-tab-text-color':'#292E43',
        '--pagination-tab-active-text-color':'#292E43',
        '--pagination-tab-active-border-color':'#292E43'
      }
    });
  }
  function load() {
    if (loading) return;
    loading = true;
    error.hidden = true;
    root.hidden = false;
    function fail(){ loading=false;root.hidden=true;error.hidden=false; }
    if (window.ReviewsWidget) {try {mount();} catch (_) {fail();} return;}
    const script=document.createElement('script');
    script.src='https://widget.reviews.co.uk/polaris/build.js';
    script.async=true;
    script.onload=()=>{try{mount();}catch(_){fail();}};
    script.onerror=()=>{script.remove();fail();};
    document.head.appendChild(script);
  }
  retry.addEventListener('click',load);
  async function checkReviewCount() {
    const skus = [...new Set((root.dataset.reviewSkus || '').split(';').filter(Boolean))];
    if (!skus.length) return;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    try {
      const url = new URL('https://api.reviews.io/product/rating-batch');
      url.searchParams.set('store', 'hadrillhair.com.au');
      url.searchParams.set('sku', skus.join(';'));
      const response = await fetch(url, {signal: controller.signal, credentials: 'omit'});
      if (!response.ok) return;
      const ratings = await response.json();
      if (!Array.isArray(ratings)) return;
      const counts = new Map();
      for (const rating of ratings) {
        if (!rating || !skus.includes(String(rating.sku))) continue;
        const count = Number(rating.num_ratings);
        if (!Number.isSafeInteger(count) || count < 0) return;
        counts.set(String(rating.sku), count);
      }
      const count = [...counts.values()].reduce((total, value) => total + value, 0);
      root.dataset.reviewCount = String(count);
      if (count < 10) return;
      section.hidden = false;
      document.querySelectorAll('.pdp__review-link').forEach(link => {link.hidden = false;});
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {observer.disconnect();load();}
        }, {rootMargin: '250px'});
        observer.observe(section);
      } else {load();}
    } catch (_) {
      section.hidden = true;
    } finally {
      clearTimeout(timeout);
    }
  }
  checkReviewCount();
})();
